import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component
import { devConfig } from 'config/config'; // Import development configuration

/**
 * Represents the ReportsCustomerView class.
 * @extends JetView
 */
export default class ReportsCustomerView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set inner layout type
                    rows: [
                        {
                            view: 'tabbar', // Create a tabbar view
                            localId: 'tabbar', // Local ID for tabbar
                            height: 43, // Set height of tabbar
                            tabMinWidth: 190, // Minimum width for tabs
                            tabMoreWidth: 80, // Width for 'more' tab
                            /**
                             * Template for the 'more' tab.
                             * @returns {string} HTML string for the 'more' tab.
                             */
                            moreTemplate: function () {
                                return (
                                    "<div style='font-weight: bold;border-left: 1px solid #ebedf0;height: 30px;line-height: 2;padding-left: 5px;color: #263043;'>" +
                                    _('Ver más') + // Localized text for 'more'
                                    '</div>'
                                );
                            },
                            options: [
                                // Options for the tabbar
                                {
                                    id: 'customers.depositReport', // Unique identifier for the deposit report tab
                                    value: _('Reporte de Depósitos'), // Localized label for the deposit report tab
                                    hidden: !devConfig.getPermAction('customersReportsDepositReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsDepositReportMenu', // CSS class for styling
                                    perm: 'customersReportsDepositReportMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.casinoGamesReport', // Unique identifier for the casino games report tab
                                    value: _('Reporte de Casino'), // Localized label for the casino games report tab
                                    hidden: !devConfig.getPermAction('customersReportsCasinoGamesReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsCasinoGamesReportMenu', // CSS class for styling
                                    perm: 'customersReportsCasinoGamesReportMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.bonusReport', // Unique identifier for the bonus report tab
                                    value: _('Reporte de Bonos'), // Localized label for the bonus report tab
                                    hidden: !devConfig.getPermAction('customersReportsBonusReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsBonusReportMenu', // CSS class for styling
                                    perm: 'customersReportsBonusReportMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.bonusReport2', // Unique identifier for the redeemed bonus report tab
                                    value: _('Reporte bonos redimidos'), // Localized label for the redeemed bonus report tab
                                    hidden: !devConfig.getPermAction('customersReportsBonusReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsBonusReportMenu', // CSS class for styling
                                    perm: 'customersReportsBonusReportMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.financial.withdrawalRequests', // Unique identifier for the withdrawal requests report tab
                                    value: _('Reporte de Retiros'), // Localized label for the withdrawal requests report tab
                                    hidden: !devConfig.getPermAction('customersReportsWithdrawalRequestsMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsWithdrawalRequestsMenu', // CSS class for styling
                                    perm: 'customersReportsWithdrawalRequestsMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.betsReport', // Unique identifier for the bets report tab
                                    value: _('Reporte de Apuestas'), // Localized label for the bets report tab
                                    hidden: !devConfig.getPermAction('customersReportsBetsReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsBetsReportMenu', // CSS class for styling
                                    perm: 'customersReportsBetsReportMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.autoexclusionUsers', // Unique identifier for the autoexclusion report tab
                                    value: _('Reporte Autoexclusión'), // Localized label for the autoexclusion report tab
                                    hidden: !devConfig.getPermAction('customersReportsAutoexclusionUsersMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsAutoexclusionUsersMenu', // CSS class for styling
                                    perm: 'customersReportsAutoexclusionUsersMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.sessionsReport2', // Unique identifier for the sessions report tab
                                    value: _('Reporte de Sesiones'), // Localized label for the sessions report tab
                                    hidden: !devConfig.getPermAction('customersReportsSessionsUsersMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsSessionsUsersMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.reports.registeredDocument', // Unique identifier for the registered document report tab
                                    value: _('Registro de Documentos'), // Localized label for the registered document report tab
                                    hidden: !devConfig.getPermAction('customersReportsRegisteredDocumentMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsRegisteredDocumentMenu', // CSS class for styling
                                    perm: 'customersReportsRegisteredDocumentMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.balanceAdjustments', // Unique identifier for the balance adjustments report tab
                                    value: _('Reporte de Ajustes de Saldos'), // Localized label for the balance adjustments report tab
                                    hidden: !devConfig.getPermAction('customersReportsBalanceAdjustmentsMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsBalanceAdjustmentsMenu', // CSS class for styling
                                    perm: 'customersReportsBalanceAdjustmentsMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.balanceHistory', // Unique identifier for the balance history report tab
                                    value: _('Historial de saldo'), // Localized label for the balance history report tab
                                    hidden: !devConfig.getPermAction('customersReportsBalanceHistoryMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsBalanceHistoryMenu', // CSS class for styling
                                    perm: 'customersReportsBalanceHistoryMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.historyMovement', // Unique identifier for the movement history report tab
                                    value: _('Historial de movimientos'), // Localized label for the movement history report tab
                                    hidden: !devConfig.getPermAction('customersReportsHistoryMovementMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsHistoryMovementMenu', // CSS class for styling
                                    perm: 'customersReportsHistoryMovementMenu', // Permission identifier
                                },
                                {
                                    id: 'customers.reports.logsUser', // Unique identifier for the user logs report tab
                                    value: _('Logs Usuario'), // Localized label for the user logs report tab
                                    hidden: !devConfig.getPermAction('customersReportsLogsUserMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsLogsUserMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.reports.walletsReport', // Unique identifier for the wallets report tab
                                    value: _('Reporte de Billeteras'), // Localized label for the wallets report tab
                                    hidden: !devConfig.getPermAction('customersReportsWalletsUsersMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsWalletsUsersMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.reports.historyPoints', // Unique identifier for the points history report tab
                                    value: _('Historial de puntos'), // Localized label for the points history report tab
                                    hidden: !devConfig.getPermAction('customersReportsHistoryPointsUsersMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsHistoryPointsUsersMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.reports.notesUser', // Unique identifier for the user notes report tab
                                    value: _('Notas de usuario'), // Localized label for the user notes report tab
                                    hidden: !devConfig.getPermAction('customersReportsNotesUserMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsNotesUserMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.referralsReport', // Unique identifier for the referrals report tab
                                    value: _('Reporte de Referidos'), // Localized label for the referrals report tab
                                    hidden: !devConfig.getPermAction('customersReportsReferralsReportMenu', 'Menu'), // Visibility based on permission
                                    css: 'prm-customersReportsReferralsReportMenu', // CSS class for styling
                                    perm: 'customersReportsReferralsReportMenu', // Permission identifier
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Ensure webix is ready before executing
            webix.attachEvent('onRotate', function (orientation) {
                // Attach event for orientation change
                window.location.reload(); // Reload the page on orientation change
            });
        });
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tabbar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
